import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExpressionDomainFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpLabeledOperatorGroupFactory } from "./ExpLabeledOperatorGroup";
// @ts-ignore noUnusedLocals
import { ExpAnonymousOperatorGroupFactory } from "./ExpAnonymousOperatorGroup";
// @ts-ignore noUnusedLocals
import { ExpExpressionDomainExtensionFactory } from "./ExpExpressionDomainExtension";
// @ts-ignore noUnusedLocals
import { ExpExecutionFlagFactory } from "./ExpExecutionFlag";
// @ts-ignore noUnusedLocals
import { ExpOperatorFactory } from "./ExpOperator";
// @ts-ignore noUnusedLocals
import { ExpOperatorRoleFactory } from "./ExpOperatorRole";
// @ts-ignore noUnusedLocals
import { ExpValueTypeFactory } from "./ExpValueType";
// @ts-ignore noUnusedLocals
import { ExpValueCategoryFactory } from "./ExpValueCategory";
// @ts-ignore noUnusedLocals
import { ExpGlobalDomainOptionsFactory } from "./ExpGlobalDomainOptions";

/**
 * 
 * @export
 * @interface ExpExpressionDomain
 */

export class ExpExpressionDomainFactory {}
_ExpExpressionDomainFactory = ExpExpressionDomainFactory;
_defineProperty(ExpExpressionDomainFactory, "FromJSON", function (json) {
  return _ExpExpressionDomainFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExpressionDomainFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'label': json['label'],
    'description': json['description'],
    'namespace': json['namespace'],
    'version': json['version'],
    'extendsDomain': json['extendsDomain'] === null || json['extendsDomain'] === undefined ? json['extendsDomain'] : ExpExpressionDomainExtensionFactory.FromJSON(json['extendsDomain']),
    'globalOptions': json['globalOptions'] === null || json['globalOptions'] === undefined ? json['globalOptions'] : ExpGlobalDomainOptionsFactory.FromJSON(json['globalOptions']),
    'valueTypes': json['valueTypes'] === null || json['valueTypes'] === undefined ? json['valueTypes'] : json['valueTypes'].map(ExpValueTypeFactory.FromJSON),
    'fallbackValueTypeID': json['fallbackValueTypeID'],
    'operators': json['operators'] === null || json['operators'] === undefined ? json['operators'] : json['operators'].map(ExpOperatorFactory.FromJSON),
    'categories': json['categories'] === null || json['categories'] === undefined ? json['categories'] : json['categories'].map(ExpValueCategoryFactory.FromJSON),
    'roles': json['roles'] === null || json['roles'] === undefined ? json['roles'] : json['roles'].map(ExpOperatorRoleFactory.FromJSON),
    'anonymousOperatorGroups': json['anonymousOperatorGroups'] === null || json['anonymousOperatorGroups'] === undefined ? json['anonymousOperatorGroups'] : json['anonymousOperatorGroups'].map(ExpAnonymousOperatorGroupFactory.FromJSON),
    'labeledOperatorGroups': json['labeledOperatorGroups'] === null || json['labeledOperatorGroups'] === undefined ? json['labeledOperatorGroups'] : json['labeledOperatorGroups'].map(ExpLabeledOperatorGroupFactory.FromJSON),
    'editorConfiguration': json['editorConfiguration'] === null || json['editorConfiguration'] === undefined ? json['editorConfiguration'] : json['editorConfiguration'],
    'executionFlags': json['executionFlags'] === null || json['executionFlags'] === undefined ? json['executionFlags'] : json['executionFlags'].map(ExpExecutionFlagFactory.FromJSON)
  };
});
_defineProperty(ExpExpressionDomainFactory, "ToJSON", function (value) {
  return _ExpExpressionDomainFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExpressionDomainFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'label': value.label,
    'description': value.description,
    'namespace': value.namespace,
    'version': value.version,
    'extendsDomain': ExpExpressionDomainExtensionFactory.ToJSON(value.extendsDomain),
    'globalOptions': ExpGlobalDomainOptionsFactory.ToJSON(value.globalOptions),
    'valueTypes': value.valueTypes === undefined ? undefined : value.valueTypes.map(ExpValueTypeFactory.ToJSON),
    'fallbackValueTypeID': value.fallbackValueTypeID,
    'operators': value.operators === undefined ? undefined : value.operators.map(ExpOperatorFactory.ToJSON),
    'categories': value.categories === undefined ? undefined : value.categories.map(ExpValueCategoryFactory.ToJSON),
    'roles': value.roles === undefined ? undefined : value.roles.map(ExpOperatorRoleFactory.ToJSON),
    'anonymousOperatorGroups': value.anonymousOperatorGroups === undefined ? undefined : value.anonymousOperatorGroups.map(ExpAnonymousOperatorGroupFactory.ToJSON),
    'labeledOperatorGroups': value.labeledOperatorGroups === undefined ? undefined : value.labeledOperatorGroups.map(ExpLabeledOperatorGroupFactory.ToJSON),
    'editorConfiguration': value.editorConfiguration,
    'executionFlags': value.executionFlags === undefined ? undefined : value.executionFlags.map(ExpExecutionFlagFactory.ToJSON)
  };
});
//# sourceMappingURL=ExpExpressionDomain.js.map
